import { css } from 'styled-components'

export const tabStyle = css`
	.MuiTabs-flexContainer {
		color: ${({ theme }) => theme.palette.text.tertiary};

		.MuiTab-root {
			opacity: 1;
			font-weight: normal;

			&.Mui-selected {
				color: ${({ theme }) => theme.palette.primary.main};
				font-weight: 800;
			}
		}

		.MuiTab-wrapper {
			${({ theme }) => theme.typography.title1}
		}
	}

	.MuiTabs-indicator {
		height: 2px;
	}
`

export const autoFieldTagStyle = css`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 5px;
	.MuiChip-deleteIcon {
		width: 14px;
		height: 14px;
	}
`

export const deleteIconStyle = css`
	width: 14px;
	height: 14px;
`

export const optionStyle = css`
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 87px;
	padding-inline: 1rem;
	${({ selected }) =>
		selected &&
		`
	border: 1px solid #B6985A;
	border-radius: 4px;
	`}
`
